var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHourGlass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.33191 2.7474C4.83357 1.66406 6.55607 1.66406 10.0002 1.66406C13.4444 1.66406 15.1669 1.66406 15.6686 2.7474C15.7119 2.83962 15.748 2.93573 15.7769 3.03573C16.1186 4.19156 14.9002 5.53156 12.4652 8.21073L10.8336 9.9974L12.4652 11.7832C14.9002 14.4632 16.1177 15.8032 15.7769 16.9582C15.748 17.0574 15.7118 17.1544 15.6686 17.2482C15.1669 18.3307 13.4444 18.3307 10.0002 18.3307C6.55607 18.3307 4.83357 18.3307 4.33191 17.2474C4.28873 17.1541 4.25252 17.0577 4.22357 16.9591C3.88191 15.8032 5.10024 14.4632 7.53524 11.7841L9.16691 9.9974L7.53524 8.21156C5.10024 5.53073 3.88357 4.19156 4.22357 3.03656C4.25246 2.93656 4.28857 2.84073 4.33191 2.7474Z",
    fill: "#5DB6CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourGlass);
export default __webpack_public_path__ + "static/media/HourGlass.2b7446749b72423ba895c6b899c55faa.svg";
export { ForwardRef as ReactComponent };